import { useMutation } from "@tanstack/react-query";
import { patch } from "../../api/client";
import {
  UpdateStudentGuardianInterface,
  UpdateStudentInfoInterface,
  UpdateStudentParentInfoInterface,
} from "../../Constants/Interfaces/payloadInterface/StudentPayload.interface";

export const useUpdateStudentInfo = ({ studentId }: { studentId: number }) =>
  useMutation((body: UpdateStudentInfoInterface) => {
    return patch({
      url: `api/v1/students/${studentId}/studentInfo`,
      body,
    });
  });

export const useUpdateStudentsParentInfo = ({
  studentId,
}: {
  studentId: number;
}) =>
  useMutation((body: UpdateStudentParentInfoInterface) => {
    return patch({
      url: `api/v1/students/${studentId}/parentInfo`,
      body: body,
    });
  });

export const useUpdateStudentsGuardianInfo = ({
  studentId,
  onSuccess,
  onError,
}: {
  studentId: number;
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
}) =>
  useMutation(
    (body: UpdateStudentGuardianInterface) => {
      return patch({
        url: `api/v1/students/${studentId}/guardianInfo`,
        body: body,
      });
    },
    {
      onSuccess,
      onError,
    }
  );
